import React from 'react';
import { motion } from 'framer-motion';
import Button from '../ui/Button';
export default function HeroSection() {
  return <section className="bg-gradient-to-b from-primary to-primary-dark text-white py-6 md:py-10" data-id="element-192">
      <div className="container mx-auto px-4" data-id="element-193">
        <div className="flex flex-col md:flex-row items-center" data-id="element-194">
          <motion.div className="md:w-1/2 mb-8 md:mb-0" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-195">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4" data-id="element-196">
              Medico-Legal Psychiatry – Expert Witness Psychiatric Services UK
            </h1>
            <p className="text-lg mb-8" data-id="element-197">
              Trusted independent psychiatric assessments and expert witness
              reports for solicitors, barristers, and courts across the UK.
              Providing specialist psychiatric evaluations for legal
              proceedings.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-198">
              <Button variant="secondary" size="lg" href="/contact" data-id="element-199">
                Instruct Dr. Syed
              </Button>
              <Button variant="transparent" size="lg" href="/services" data-id="element-200">
                Our Services
              </Button>
            </div>
          </motion.div>
          <motion.div className="md:w-1/2 flex justify-center" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-201">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/u9Nr778koLscH9uY6kZjEn/01._Hero_Image.png" alt="Dr. Imtiaz Syed – GMC-registered Psychiatrist and accredited medico-legal expert witness" className="rounded-lg shadow-xl max-w-full h-auto w-3/4" data-id="element-202" />
          </motion.div>
        </div>
      </div>
    </section>;
}